import {Component} from "react";
import * as React from "react";
import {Switch} from "../../buttons/Swtich";

export class SingleLevelIndicatorSensitivity extends Component {
    constructor(props) {
        super(props);
        this.handleSensitivityChange = this.handleSensitivityChange.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.className = this.className.bind(this);
    }

    render() {
        return (
            <div className="form-item">
                <div className="toggle-input-header">
                    <Switch style={{paddingTop:"0.3em"}} onChange={this.handleStatusChange} checked={this.props.isActive}/>
                    <div className="combined-label" style={{paddingTop:"0.4em"}}>
                        <p className="combined-label-title">{this.props.indicatorTitle}</p>
                        <p className="combined-label-subtitle">{this.props.indicatorSubtitle}</p>
                    </div>
                    <input onChange={this.handleSensitivityChange}
                           className={this.className()}
                           readOnly={'readonly' ? !this.props.isActive : ''}
                           value={this.props.sensitivityValues[0].value}
                           type="number" placeholder="%"
                           style={{width:"25%"}}
                    />
                    <div className="combined-label" style={{paddingTop:"0.4em"}}>
                        <p className="combined-label-title">&nbsp;%</p>
                    </div>
                </div>

            </div>
        )
    }

    handleSensitivityChange(event) {
        let target = event.target;
        this.handleSensitivityChangeForAllLevels(target.value);
    }

    className() {
        if (!this.props.isActive) {
            return 'form-control-plaintext'
        }
    }

    handleSensitivityChangeForAllLevels(value) {
        this.props.sensitivityValues.forEach(sensitivityValue => {
            this.props.handleSensitivityChange(this.props.indicatorName, sensitivityValue.level, value)
        })
    }

    handleStatusChange(event) {
        let target = event.target;
        let shouldActivate = target.checked;

        this.props.handleStatusChange(this.props.indicatorName, shouldActivate)
    }
}
